import React, { useEffect, useState } from 'react';
import UserGetData from '../../usecases/UserGetData'
import CacheLoadCredentials from '../../usecases/CacheLoadCredentials'
import RowContainer from '../basic/RowContainer';
import RowContainerItem from '../basic/RowContainerItem';
import CustomersList from '../specific/CustomersList';
import BasicCard from '../basic/BasicCard';
import Refresh from '../basic/Refresh';
import { Info, RecentActors } from '@mui/icons-material';
import InfoCard from '../basic/InfoCard';
import UsersChart from '../specific/UsersChart';
import { yellow } from '@mui/material/colors';
import { Divider } from '@mui/material';
import values from '../../values/values';

const Customer = () => {

    const [users, setUsers] = useState([])
    const [clientes, setClientes] = useState([]);
    const [loading, setloading] = useState(false);
    const [usuarioLogado, setUsuarioLogado] = useState([]);
    const [newUsers, setNewUsers] = useState(0);
    const [userBloquados, setUserBloquados] = useState(0);

    useEffect(() => {
        CacheLoadCredentials().then(res => {
            if(res && res.tipo)
            setUsuarioLogado(res.tipo)
        })
        getCustomers()
    }, [])

    const getCustomers = () => {
        setloading(true)
        UserGetData().then(items => {
            setloading(true)
            setUsers(items)
        })
        .catch(err => {
            console.error('Erro: ', err)
        })
        .finally(() => {
            console.error('Finally')
            setloading(false)
        })
    }
    
    useEffect(() => {
    let clientes = users.filter(item => item.tipo === 'CLI')
    setClientes(clientes)
    
}, [users])

useEffect(() => {
    let data = new Date()
    let last30Days = data.setDate(data.getDate() - 30)
    let newUsers = 0;
    let bloqueados = 0;

        clientes.forEach(item => {
            if (item.data_cad_server === data || item.data_cad_server >= last30Days) {
                newUsers++
            }
            else if (item.autorizado === 0 || item.autorizado === 'false') {
                bloqueados++
            }
        })

        setNewUsers(newUsers)
        setUserBloquados(bloqueados)
}, [clientes])


    return (
        <div>
            <RowContainer>
                <RowContainerItem minHeight={100}>
                        <InfoCard title="Total de Usuarios" value={clientes.length} height={100} />
                        <Divider oritentation="vertical" flexItem style={{margin: values.margin[1]}} />
                        <InfoCard title="Novos Usuarios no ultimo mês" value={newUsers} height={100} />
                        <Divider oritentation="vertical" flexItem style={{margin: values.margin[1]}} />
                        <InfoCard title="Usuarios Bloqueados" value={userBloquados} height={100} />   
                </RowContainerItem>
               {/*<RowContainerItem height={700}>
                    <BasicCard>
                        <UsersChart
                            style={{ flex:1, 'nowrap': true}}
                            items={clientes} />
                    </BasicCard>
                </RowContainerItem>
                <RowContainerItem height={700}>
                    <BasicCard>
                        <UsersChart 
                            style={{flex:1, 'nowrap':true}}
                            items={users}/>
                    </BasicCard>
                </RowContainerItem>
                <RowContainerItem>
                    
                </RowContainerItem>*/}
            </RowContainer>
            <RowContainer>
                <RowContainerItem minWidth={400}>
                <BasicCard >
                        <RecentActors style={{ marginRight: '8px' }} sx={{fontSize:35 , color: yellow['A700']}} />
                        <CustomersList
                            style = {{flex: 1, 'noWrap': true, with:500}}
                            items = {clientes} 
                            rowsPerPage = {25}
                            refresh = {getCustomers}/>
                        <Refresh onClick={getCustomers}/>
                    </BasicCard>
                </RowContainerItem>
            </RowContainer>
        </div>
    );
}

export default Customer;